import * as React from 'react';
import AnimatableDiv from 'shared/symbols/AnimatableDiv';
import { mouseEventProps } from '../mouseEventProps';
import { joinClass } from '../symbolUtils';
import { calcClasses, calcTextStyles } from './calcUtils';
import { useTextScale } from './useTextScale';
export var textAttributeStyleMap = {
    horizontalAlignment: {
        left: { textAlign: 'left' },
        center: { textAlign: 'center' },
        right: { textAlign: 'right' },
        justify: { textAlign: 'justify' },
    },
    verticalAlignment: {
        top: { alignItems: 'flex-start' },
        center: { alignItems: 'center' },
        bottom: { alignItems: 'flex-end' },
    },
};
var Text = function (props) {
    var conditionalState = props.conditionalState, hoverAnimation = props.hoverAnimation, symbol = props.symbol, timelineRefId = props.timelineRefId, innerRef = props.innerRef, inEditor = props.inEditor;
    var internalRef = React.useRef(null);
    var containerRef = innerRef || internalRef;
    var scale = useTextScale(containerRef, props)[0];
    var _a = mouseEventProps(symbol, inEditor, hoverAnimation), clickClass = _a.clickClass, onClick = _a.onClick;
    var attributes = conditionalState.attributes, position = conditionalState.position;
    var content = attributes ? attributes.content : '';
    var textClass = calcClasses(props, scale);
    var className = joinClass(textClass, clickClass);
    return (React.createElement(AnimatableDiv, { className: className, hoverAnimation: hoverAnimation, id: timelineRefId, innerRef: containerRef, inEditor: inEditor, onClick: onClick, style: calcTextStyles(props, scale), position: position },
        React.createElement("div", { style: {
                boxSizing: 'border-box',
                cursor: 'inherit',
                width: '100%',
            }, dangerouslySetInnerHTML: { __html: content } })));
};
export default Text;
